export class RpcLoggerFactory {
    constructor(requestLoggerClass) {
        this._nextId = 0;
        this._requestLoggerClass = requestLoggerClass;
    }
    build() {
        return new this._requestLoggerClass(this._nextId++);
    }
}
// https://material.io/guidelines/style/color.html#color-color-palette
const COLORS = [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFEB3B',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B', // blue grey
];
export class ConsoleRequestLogger {
    constructor(id, colors, console = window.console) {
        this.id = id;
        this.colors = colors || COLORS;
        this.console = console;
    }
    getColor() {
        return this.colors[this.id % this.colors.length];
    }
    logRequest(method, url, requestData) {
        const { resolvedRequestType } = method.resolve();
        this.console.groupCollapsed(`%cRPC#${this.id} ↑ %c${url}`, 'color:blue', `color:${this.getColor()}`);
        this.console.log(resolvedRequestType.decode(requestData));
        this.console.groupEnd();
    }
    logResponse(method, url, responseData) {
        const { resolvedResponseType } = method.resolve();
        this.console.groupCollapsed(`%cRPC#${this.id} ↓ %c${url}`, 'color:green', `color:${this.getColor()}`);
        this.console.log(resolvedResponseType.decode(responseData));
        this.console.groupEnd();
    }
    logError(_method, url, error) {
        this.console.groupCollapsed(`%cRPC#${this.id} ↓ %c${url}`, 'color:red', `color:${this.getColor()}`);
        this.console.log(error);
        this.console.groupEnd();
    }
}
export class SilentRequestLogger {
    constructor(id) {
        this.id = id;
    }
    logRequest() {
        // Does nothing
    }
    logResponse() {
        // Does nothing
    }
    logError() {
        // Does nothing
    }
}
export class ConsoleLoggerFactory extends RpcLoggerFactory {
    constructor(enabled) {
        super(enabled ? ConsoleRequestLogger : SilentRequestLogger);
    }
}
